export default "__VITE_ASSET__Dh$8Lay$__"